import { render, staticRenderFns } from "./activity-sign.vue?vue&type=template&id=5c738182&scoped=true&"
import script from "./activity-sign.vue?vue&type=script&lang=js&"
export * from "./activity-sign.vue?vue&type=script&lang=js&"
import style0 from "./activity-sign.vue?vue&type=style&index=0&id=5c738182&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c738182",
  null
  
)

export default component.exports